import { useHomeText } from '../text';

const About = () => {
  const t = useHomeText();
  return (
    <section id="about" style={{ maxWidth: "1280px", margin: "0 auto", padding: "104px 24px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(480px, 100%), 1fr))", gap: "56px", alignItems: "center" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
          {t.about.aboutUs}
        </span>
        <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2", width: "min(672px, calc(100vw - 48px))" }}>
          <ul dir={t.about.ltrDir}>
            <li>
              <strong>
                {t.about.aGenerationThatLearns}
              </strong>
            </li>
          </ul>
        </h2>
        <div style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
          <div dir={t.about.ltrDir}>
            <p dir={t.about.ltrDir}>
              {t.about.khotouaIsAnEducational}
            </p>
            {" "}
            <div dir={t.about.ltrDir} style={{ margin: "8px 0", display: "flex", flexDirection: "column", gap: "12px", padding: "22px 24px", borderRadius: "24px", background: "#F1EDFF", border: "2px solid #D9CFFF", boxShadow: "0 6px 0 #D9CFFF" }}>
              <span style={{ alignSelf: "flex-start", display: "inline-flex", alignItems: "center", gap: "8px", padding: "5px 14px", borderRadius: "999px", background: "#5B3FB0", color: "#FFFFFF", fontWeight: "800", fontSize: "14px" }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="6" y="2.5" width="12" height="19" rx="3" />
                  <path d="M10.5 18.5h3" />
                </svg>
                {t.about.generationAlpha}
                <span dir="ltr">
                  Gen Alpha
                </span>
              </span>
              <p dir={t.about.ltrDir} style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', 'IBM Plex Sans Arabic', sans-serif", fontWeight: "700", fontSize: "clamp(20px, 2vw, 24px)", lineHeight: "1.75", color: "#141C63" }}>
                {t.about.designedEspecially}
                <span style={{ color: "#5B3FB0", fontWeight: "800" }}>
                  {t.about.forGenerationAlpha}
                </span>
                {t.about.aGenerationBornWith}
                <span style={{ padding: "0 8px", borderRadius: "10px", background: "#CFF5EE", color: "#0B5F55" }}>
                  {t.about.throughImages}
                </span>
                {" "}
                <span style={{ padding: "0 8px", borderRadius: "10px", background: "#FFE3C7", color: "#8A3E05" }}>
                  {t.about.movement}
                </span>
                {" "}
                <span style={{ padding: "0 8px", borderRadius: "10px", background: "#FCD9EC", color: "#8E1F5F" }}>
                  {t.about.andInteraction}
                </span>
                {t.about.andWhoNeedExperiences}
                <span style={{ color: "#1E8F80", fontWeight: "800" }}>
                  {t.about.curiosity}
                </span>
                .
              </p>
            </div>
            {" "}
            <p dir={t.about.ltrDir}>
              {t.about.byCombiningPlayWith}
            </p>
          </div>
          {" "}
          <p dir={t.about.ltrDir}>
            <br />
          </p>
        </div>
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <span style={{ padding: "8px 16px", borderRadius: "999px", background: "#E2F7F3", color: "#145E55", fontWeight: "700", fontSize: "14px" }}>
            {t.about.augmentedReality}
          </span>
          <span style={{ padding: "8px 16px", borderRadius: "999px", background: "#E6E9FF", color: "#1C2580", fontWeight: "700", fontSize: "14px" }}>
            {t.about.artificialIntelligence}
          </span>
          <span style={{ padding: "8px 16px", borderRadius: "999px", background: "#FFF3CC", color: "#6E4A00", fontWeight: "700", fontSize: "14px" }}>
            {t.about.t2d3dGames}
          </span>
          <span style={{ padding: "8px 16px", borderRadius: "999px", background: "#FDE6F3", color: "#8E1F5F", fontWeight: "700", fontSize: "14px" }}>
            {t.about.personalisedLearning}
          </span>
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <img width="1376" height="768" loading="lazy" decoding="async" src="/assets/img/kids-ar-vr-school.webp" alt={t.about.childrenLearningWithVirtualAlt} style={{ width: "100%", borderRadius: "32px", display: "block", boxShadow: "0 30px 60px rgba(20,28,99,0.2)" }} />
      </div>
    </section>
  );
};

export default About;
